import { Component, ViewEncapsulation } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { FuseLoadingBarComponent } from "@fuse/components/loading-bar";

@Component({
    selector: "empty-layout",
    templateUrl: "./empty.component.html",
    encapsulation: ViewEncapsulation.None,
    imports: [FuseLoadingBarComponent, RouterOutlet]
})
export class EmptyLayoutComponent {}
